// ─── src/api/meetupFeedbacks.ts ──────────────────────────────────────────────

import { apiClient } from "./registration";

// ── Types shared with the backend ────────────────────────────────────────────

export interface MeetupFeedback {
  id: string;
  eventId: string;
  /** Null for public-link submissions (no ticket-token identity). */
  attendeeId: string | null;
  /** Present only for public-link submissions — dedupe key for that flow. */
  respondentEmail?: string | null;
  ratingOverall: number;
  nps: number;
  mostUsefulPart: string;
  ratingVenueOrganization: number;
  ratingSpeakers: number;
  ratingTopic: number;
  wantedTopics?: string | null;
  quoteConsent: boolean;
  quote?: string | null;
  hearAbout: string;
  hearAboutOther?: string | null;
  shouldHaveAttended?: string | null;
  improvement?: string | null;
  createdAt: string;
  // Joined by the service — the attendee's name + email are handy in the
  // dashboard table.
  attendee?: {
    id: string;
    fullName: string;
    email: string;
    whatsapp?: string;
    governorate?: string;
  };
}

export interface MeetupFeedbackStats {
  total: number;
  quotesConsented: number;
  averageOverall: number;
  averageVenueOrganization: number;
  averageSpeakers: number;
  averageTopic: number;
  averageNps: number;
  npsScore: number;
  promoters: number;
  detractors: number;
  passives: number;
  byHearAbout: Record<string, number>;
}

// ── Calls ────────────────────────────────────────────────────────────────────

const BASE = "/meetup-feedbacks";

export const getMeetupFeedbacks = async (
  eventId?: string,
): Promise<{ data: MeetupFeedback[]; total: number }> => {
  const { data } = await apiClient.get<{ data: MeetupFeedback[]; total: number }>(
    BASE,
    { params: eventId ? { eventId } : {} },
  );
  return data;
};

export const getMeetupFeedbackStats = async (
  eventId?: string,
): Promise<MeetupFeedbackStats> => {
  const { data } = await apiClient.get<MeetupFeedbackStats>(`${BASE}/stats`, {
    params: eventId ? { eventId } : {},
  });
  return data;
};

export const deleteMeetupFeedback = async (id: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`);
};
